"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
var types_1 = require("./types");
var static_1 = require("./static");
exports.GovRealms = [
  types_1.Realm.OC11,
  types_1.Realm.OC12,
  types_1.Realm.OC2,
  types_1.Realm.OC3,
  types_1.Realm.OC4,
];
exports.NonGovRealms = [
  types_1.Realm.R1,
  types_1.Realm.OC1,
  types_1.Realm.OC10,
  types_1.Realm.OC13,
  types_1.Realm.OC14,
  types_1.Realm.OC15,
  types_1.Realm.OC16,
  types_1.Realm.OC17,
  types_1.Realm.OC18,
  types_1.Realm.OC5,
  types_1.Realm.OC8,
  types_1.Realm.OC9,
];
exports.DisconnectedRealms = [
  types_1.Realm.OC11,
  types_1.Realm.OC12,
  types_1.Realm.OC5,
  types_1.Realm.OC6,
  types_1.Realm.OC7,
];
exports.RegionToRealmMap =
  ((_a = {}),
  (_a[types_1.Region.ALW] = types_1.Realm.R1),
  (_a[types_1.Region.R1A] = types_1.Realm.R1),
  (_a[types_1.Region.R1B] = types_1.Realm.R1),
  (_a[types_1.Region.R1G] = types_1.Realm.R1),
  (_a[types_1.Region.RNT] = types_1.Realm.R1),
  (_a[types_1.Region.SCF] = types_1.Realm.R1),
  (_a[types_1.Region.SEA] = types_1.Realm.R1),
  (_a[types_1.Region.AMS] = types_1.Realm.OC1),
  (_a[types_1.Region.ARN] = types_1.Realm.OC1),
  (_a[types_1.Region.AUH] = types_1.Realm.OC1),
  (_a[types_1.Region.BOM] = types_1.Realm.OC1),
  (_a[types_1.Region.CDG] = types_1.Realm.OC1),
  (_a[types_1.Region.CWL] = types_1.Realm.OC1),
  (_a[types_1.Region.DXB] = types_1.Realm.OC1),
  (_a[types_1.Region.FRA] = types_1.Realm.OC1),
  (_a[types_1.Region.GRU] = types_1.Realm.OC1),
  (_a[types_1.Region.HYD] = types_1.Realm.OC1),
  (_a[types_1.Region.IAD] = types_1.Realm.OC1),
  (_a[types_1.Region.ICN] = types_1.Realm.OC1),
  (_a[types_1.Region.JED] = types_1.Realm.OC1),
  (_a[types_1.Region.JNB] = types_1.Realm.OC1),
  (_a[types_1.Region.KIX] = types_1.Realm.OC1),
  (_a[types_1.Region.LHR] = types_1.Realm.OC1),
  (_a[types_1.Region.LIN] = types_1.Realm.OC1),
  (_a[types_1.Region.MAD] = types_1.Realm.OC1),
  (_a[types_1.Region.MC] = types_1.Realm.OC1),
  (_a[types_1.Region.MEL] = types_1.Realm.OC1),
  (_a[types_1.Region.MRS] = types_1.Realm.OC1),
  (_a[types_1.Region.MTZ] = types_1.Realm.OC1),
  (_a[types_1.Region.NRT] = types_1.Realm.OC1),
  (_a[types_1.Region.NUM] = types_1.Realm.OC1),
  (_a[types_1.Region.ORD] = types_1.Realm.OC1),
  (_a[types_1.Region.PHX] = types_1.Realm.OC1),
  (_a[types_1.Region.QRO] = types_1.Realm.OC1),
  (_a[types_1.Region.SCL] = types_1.Realm.OC1),
  (_a[types_1.Region.SIN] = types_1.Realm.OC1),
  (_a[types_1.Region.SJC] = types_1.Realm.OC1),
  (_a[types_1.Region.SYD] = types_1.Realm.OC1),
  (_a[types_1.Region.VCP] = types_1.Realm.OC1),
  (_a[types_1.Region.YNY] = types_1.Realm.OC1),
  (_a[types_1.Region.YUL] = types_1.Realm.OC1),
  (_a[types_1.Region.YYZ] = types_1.Realm.OC1),
  (_a[types_1.Region.ZRH] = types_1.Realm.OC1),
  (_a[types_1.Region.WGA] = types_1.Realm.OC10),
  (_a[types_1.Region.DAL] = types_1.Realm.OC11),
  (_a[types_1.Region.GYR] = types_1.Realm.OC11),
  (_a[types_1.Region.HEF] = types_1.Realm.OC11),
  (_a[types_1.Region.PIT] = types_1.Realm.OC11),
  (_a[types_1.Region.GEU] = types_1.Realm.OC12),
  (_a[types_1.Region.OKV] = types_1.Realm.OC12),
  (_a[types_1.Region.VEL] = types_1.Realm.OC12),
  (_a[types_1.Region.TUU] = types_1.Realm.OC13),
  (_a[types_1.Region.BGY] = types_1.Realm.OC14),
  (_a[types_1.Region.DTM] = types_1.Realm.OC14),
  (_a[types_1.Region.DUS] = types_1.Realm.OC14),
  (_a[types_1.Region.MXP] = types_1.Realm.OC14),
  (_a[types_1.Region.ORK] = types_1.Realm.OC14),
  (_a[types_1.Region.SNN] = types_1.Realm.OC14),
  (_a[types_1.Region.DAC] = types_1.Realm.OC15),
  (_a[types_1.Region.SGU] = types_1.Realm.OC16),
  (_a[types_1.Region.GCN] = types_1.Realm.OC17),
  (_a[types_1.Region.IFP] = types_1.Realm.OC17),
  (_a[types_1.Region.PRC] = types_1.Realm.OC18),
  (_a[types_1.Region.LFI] = types_1.Realm.OC2),
  (_a[types_1.Region.LUF] = types_1.Realm.OC2),
  (_a[types_1.Region.PIA] = types_1.Realm.OC3),
  (_a[types_1.Region.RIC] = types_1.Realm.OC3),
  (_a[types_1.Region.TUS] = types_1.Realm.OC3),
  (_a[types_1.Region.BRS] = types_1.Realm.OC4),
  (_a[types_1.Region.LTN] = types_1.Realm.OC4),
  (_a[types_1.Region.TIW] = types_1.Realm.OC5),
  (_a[types_1.Region.DCA] = types_1.Realm.OC6),
  (_a[types_1.Region.FTW] = types_1.Realm.OC6),
  (_a[types_1.Region.BWI] = types_1.Realm.OC7),
  (_a[types_1.Region.NJA] = types_1.Realm.OC8),
  (_a[types_1.Region.UKB] = types_1.Realm.OC8),
  (_a[types_1.Region.MCT] = types_1.Realm.OC9),
  _a);
exports.OciToOcicRegionsMap =
  ((_b = {}),
  (_b[types_1.Region.ALW] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.RNT] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.SCF] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.SEA] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.AMS] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.ARN] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.AUH] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.BOM] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.CDG] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.CWL] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.DXB] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.FRA] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.GRU] = [static_1.OcicRegion.LAD_REGION]),
  (_b[types_1.Region.HYD] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.IAD] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.ICN] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.JED] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.JNB] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.KIX] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.LHR] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.LIN] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.MAD] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.MEL] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.MRS] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.MTZ] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.NRT] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.NUM] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.ORD] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.PHX] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.SCL] = [static_1.OcicRegion.LAD_REGION]),
  (_b[types_1.Region.SIN] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.SJC] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.SYD] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.VCP] = [static_1.OcicRegion.LAD_REGION]),
  (_b[types_1.Region.YNY] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.YUL] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.YYZ] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.ZRH] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.DAL] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.GYR] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.HEF] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.PIT] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.GEU] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.OKV] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.VEL] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.TUU] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.BGY] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.DTM] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.DUS] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.MXP] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.ORK] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.SNN] = [
    static_1.OcicRegion.EMEA_REGION,
    static_1.OcicRegion.UK001,
  ]),
  (_b[types_1.Region.DAC] = [static_1.OcicRegion.APAC_REGION]),
  (_b[types_1.Region.SGU] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.GCN] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.IFP] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.PRC] = [
    static_1.OcicRegion.NORTH_AMERICA_REGION,
    static_1.OcicRegion.US001,
    static_1.OcicRegion.US002,
  ]),
  (_b[types_1.Region.LFI] = [static_1.OcicRegion.USGOV]),
  (_b[types_1.Region.LUF] = [static_1.OcicRegion.USGOV]),
  (_b[types_1.Region.PIA] = [static_1.OcicRegion.USDOD]),
  (_b[types_1.Region.RIC] = [static_1.OcicRegion.USDOD]),
  (_b[types_1.Region.TUS] = [static_1.OcicRegion.USDOD]),
  (_b[types_1.Region.BRS] = [static_1.OcicRegion.UKGOV]),
  (_b[types_1.Region.LTN] = [static_1.OcicRegion.UKGOV]),
  (_b[types_1.Region.TIW] = [static_1.OcicRegion.USGOV]),
  (_b[types_1.Region.DCA] = [static_1.OcicRegion.USGOV]),
  (_b[types_1.Region.FTW] = [static_1.OcicRegion.USGOV]),
  (_b[types_1.Region.BWI] = [static_1.OcicRegion.USGOV]),
  _b);
exports.RegionFriendlyNameMap =
  ((_c = {}),
  (_c[types_1.Region.ALW] = "US Dev West (Walla Walla)"),
  (_c[types_1.Region.R1A] = "R1A"),
  (_c[types_1.Region.R1B] = "R1B"),
  (_c[types_1.Region.R1G] = "R1G"),
  (_c[types_1.Region.RNT] = "US Dev West (Renton)"),
  (_c[types_1.Region.SCF] = "US Dev West (Scottsdale)"),
  (_c[types_1.Region.SEA] = "US Dev West (Seattle)"),
  (_c[types_1.Region.AMS] = "Netherlands Northwest (Amsterdam)"),
  (_c[types_1.Region.ARN] = "Sweden Central (Stockholm)"),
  (_c[types_1.Region.AUH] = "UAE Central (Abu Dhabi)"),
  (_c[types_1.Region.BOM] = "India West (Mumbai)"),
  (_c[types_1.Region.CDG] = "France Central (Paris)"),
  (_c[types_1.Region.CWL] = "UK West (Newport)"),
  (_c[types_1.Region.DXB] = "UAE East (Dubai)"),
  (_c[types_1.Region.FRA] = "Germany Central (Frankfurt)"),
  (_c[types_1.Region.GRU] = "Brazil East (Sao Paulo)"),
  (_c[types_1.Region.HYD] = "India South (Hyderabad)"),
  (_c[types_1.Region.IAD] = "US East (Ashburn)"),
  (_c[types_1.Region.ICN] = "South Korea Central (Seoul)"),
  (_c[types_1.Region.JED] = "Saudi Arabia West (Jeddah)"),
  (_c[types_1.Region.JNB] = "South Africa Central (Johannesburg)"),
  (_c[types_1.Region.KIX] = "Japan Central (Osaka)"),
  (_c[types_1.Region.LHR] = "UK South (London)"),
  (_c[types_1.Region.LIN] = "Italy Northwest (Milan)"),
  (_c[types_1.Region.MAD] = "Spain Central (Madrid)"),
  (_c[types_1.Region.MEL] = "Australia Southeast (Melbourne)"),
  (_c[types_1.Region.MRS] = "France South (Marseille)"),
  (_c[types_1.Region.MTZ] = "Israel Central (Jerusalem)"),
  (_c[types_1.Region.NRT] = "Japan East (Tokyo)"),
  (_c[types_1.Region.NUM] = "Saudi Arabia Northwest (Neom)"),
  (_c[types_1.Region.ORD] = "US Midwest (Chicago)"),
  (_c[types_1.Region.PHX] = "US West (Phoenix)"),
  (_c[types_1.Region.QRO] = "Mexico Central (Queretaro)"),
  (_c[types_1.Region.SCL] = "Chile Central (Santiago)"),
  (_c[types_1.Region.SIN] = "Singapore (Singapore)"),
  (_c[types_1.Region.SJC] = "US West (San Jose)"),
  (_c[types_1.Region.SYD] = "Australia East (Sydney)"),
  (_c[types_1.Region.VCP] = "Brazil South East (Vinhedo)"),
  (_c[types_1.Region.YNY] = "South Korea North (Chuncheon)"),
  (_c[types_1.Region.YUL] = "Canada Southeast (Montreal)"),
  (_c[types_1.Region.YYZ] = "Canada Southeast (Toronto)"),
  (_c[types_1.Region.ZRH] = "Switzerland North (Zurich)"),
  (_c[types_1.Region.WGA] = "Australia Dedicated Region (Canberra)"),
  (_c[types_1.Region.DAL] = "US Gov Secret South Central (Fort Worth)"),
  (_c[types_1.Region.GYR] = "US Gov Secret West (Phoenix)"),
  (_c[types_1.Region.HEF] = "US Gov Secret East 2 (Sterling)"),
  (_c[types_1.Region.PIT] = "US Gov Top Secret East (Boyers)"),
  (_c[types_1.Region.GEU] = "US Gov Top Secret West (Phoenix)"),
  (_c[types_1.Region.OKV] = "US Gov Top Secret East (Ashburn)"),
  (_c[types_1.Region.VEL] = "US Gov Top Secret West (Salt Lake City)"),
  (_c[types_1.Region.TUU] = "NEOM Dedicated Region"),
  (_c[types_1.Region.BGY] = "Vodafone Dedicated Region  (Milan 1)"),
  (_c[types_1.Region.DTM] = "Vodafone Dedicated Region (Ratingen 2)"),
  (_c[types_1.Region.DUS] = "Vodafone Dedicated Region (Ratingen 1)"),
  (_c[types_1.Region.MXP] = "Vodafone Dedicated Region (Milan 2)"),
  (_c[types_1.Region.ORK] = "Vodafone Dedicated Region (Dublin 1)"),
  (_c[types_1.Region.SNN] = "Vodafone Dedicated Region (Dublin 2)"),
  (_c[types_1.Region.DAC] = "BDCCL Dedicated Region"),
  (_c[types_1.Region.SGU] = "US Dev West (West Jordan)"),
  (_c[types_1.Region.GCN] = "US Dev West 2 (Phoenix)"),
  (_c[types_1.Region.IFP] = "US Dev West (Phoenix)"),
  (_c[types_1.Region.PRC] = "US Dev West 3 (Phoenix)"),
  (_c[types_1.Region.LFI] = "US Gov East (Ashburn)"),
  (_c[types_1.Region.LUF] = "US Gov West (Phoenix)"),
  (_c[types_1.Region.PIA] = "US DoD North (Chicago)"),
  (_c[types_1.Region.RIC] = "US DoD East (Ashburn)"),
  (_c[types_1.Region.TUS] = "US DoD West (Phoenix)"),
  (_c[types_1.Region.BRS] = "UK Gov West (Newport)"),
  (_c[types_1.Region.LTN] = "UK Gov South (London)"),
  (_c[types_1.Region.TIW] = "US Dev West (Tacoma)"),
  (_c[types_1.Region.DCA] = "US Gov Top Secret East (Sterling)"),
  (_c[types_1.Region.FTW] = "US Gov Top Secret South Central (Fort Worth)"),
  (_c[types_1.Region.BWI] = "US Gov Top Secret East (Sterling)"),
  (_c[types_1.Region.NJA] = "NRI Dedicated Region"),
  (_c[types_1.Region.UKB] = "NRI Dedicated Region (Osaka)"),
  (_c[types_1.Region.MCT] = "Oman Dedicated Region"),
  _c);
exports.RegionLocationMap =
  ((_d = {}),
  (_d[types_1.Region.ALW] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.R1A] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.R1B] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.R1G] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.RNT] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.SCF] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.SEA] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.AMS] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.ARN] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.AUH] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.BOM] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.CDG] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.CWL] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.DXB] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.FRA] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.GRU] = static_1.RegionLocation.SouthAmerica),
  (_d[types_1.Region.HYD] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.IAD] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.ICN] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.JED] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.JNB] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.KIX] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.LHR] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.LIN] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.MAD] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.MEL] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.MRS] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.MTZ] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.NRT] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.NUM] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.ORD] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.PHX] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.QRO] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.SCL] = static_1.RegionLocation.SouthAmerica),
  (_d[types_1.Region.SIN] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.SJC] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.SYD] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.VCP] = static_1.RegionLocation.SouthAmerica),
  (_d[types_1.Region.YNY] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.YUL] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.YYZ] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.ZRH] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.WGA] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.DAL] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.GYR] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.HEF] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.PIT] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.GEU] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.OKV] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.VEL] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.TUU] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.BGY] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.DTM] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.DUS] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.MXP] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.ORK] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.SNN] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.DAC] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.SGU] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.GCN] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.IFP] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.PRC] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.LFI] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.LUF] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.PIA] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.RIC] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.TUS] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.BRS] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.LTN] = static_1.RegionLocation.EMEA),
  (_d[types_1.Region.TIW] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.DCA] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.FTW] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.BWI] = static_1.RegionLocation.NorthAmerica),
  (_d[types_1.Region.NJA] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.UKB] = static_1.RegionLocation.APAC),
  (_d[types_1.Region.MCT] = static_1.RegionLocation.EMEA),
  _d);
